function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.88 20.92c.03.16-.06.33-.21.39-1.14.45-2.37.69-3.66.69a9.9 9.9 0 01-5.9-1.93c-.14-.1-.18-.3-.09-.45.55-.98 2.7-4.13 7.45-5.89.18-.07.38.02.44.2 1.2 3.19 1.76 5.89 1.97 6.99zm5.94-7.03a9.89 9.89 0 01-3.77 6.06c-.21.16-.51.04-.56-.21-.21-1.08-.72-3.41-1.7-6.18-.07-.21.07-.44.29-.47 2.49-.3 4.67.18 5.49.4.17.06.28.23.25.4z"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M21.59 11.82c-1.02-.18-3.62-.56-6.28-.27-.16.02-.3-.07-.37-.22-.04-.09-.07-.18-.11-.27-.16-.37-.33-.75-.5-1.12-.09-.18 0-.4.18-.48 2.8-1.21 4.36-2.77 4.97-3.47.15-.17.41-.16.55.02A9.896 9.896 0 0122 11.43c.01.25-.19.43-.41.39z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M18.44 4.79c-.52.63-1.98 2.13-4.75 3.23a.35.35 0 01-.44-.16 53.586 53.586 0 00-3.27-5.15.358.358 0 01.23-.56c.58-.1 1.18-.15 1.8-.15 2.42 0 4.65.86 6.38 2.3.15.12.17.34.05.49zm-7.42 4.05c-3.79.95-7.14 1.08-8.36 1.1-.23 0-.4-.22-.34-.44.72-2.8 2.64-5.14 5.17-6.43.15-.08.34-.03.44.11.52.72 1.93 2.75 3.31 5.14.11.2.01.46-.22.52z"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.92 11.6c.09.19-.02.42-.22.49-4.43 1.43-7.08 4.98-7.88 6.2-.13.2-.41.21-.56.03C2.85 16.6 2 14.63 2 12.23v-.18c0-.2.16-.36.36-.35 1.26.05 5.37-.12 9.64-1.35.16-.05.34.03.41.18.18.36.35.71.51 1.07z"
})));